export var normalizeSize = function normalizeSize(size) {
  if (typeof size === "number") return "".concat(size, "px");
  return "".concat(size);
};